import {EmailService} from '../../email/email.service';
import {Forms} from '../../tools/forms/forms.class';
import {gaLegacyCustomEvent} from '../../ga/ga-legacy.functions';
import {ImpError} from '../../imp-error/imp-error.class';
import {ProgressOverlay} from '../../components/ProgressOverlay';
import {RecaptchaComponent} from '../../recaptcha/recaptcha.component';
import {SendEmailParams} from '../../../shared/email/email.class';

require('../../vendor/jquery.validate/jquery.validate.min.js');

export class ServiceDetailComponent {
    public component: JQuery;
    public componentName = `default-cms-content`;
    public emailForm: JQuery;
    public emailFormData: JQuery;
    public error: JQuery;
    public errorMessage: JQuery;
    public impSpinner: JQuery;
    public impSpinnerSize: JQuery;
    public success: JQuery;
    private _disableRecaptcha: boolean;
    private _recaptchaComponent: RecaptchaComponent;

    constructor(private _emailService: EmailService) {
        this.component = $(`[data-component='${this.componentName}']`);
        this._onInit();
    }

    private _onInit() {
        this._getServerTemplateData();
        this._performElementBinding();
        this._registerEventHandlers();
    }

    /**
     * Submits the web login request
     */
    public submitWebForm() {
        ProgressOverlay.activate();
        if (this.emailFormData.valid()) {
            const sendEmailParams: SendEmailParams = Forms.convertSerializedArrayToObject(this.emailFormData.serializeArray());
            sendEmailParams.body = `Name: ${sendEmailParams.name}\r\nEmail: ${sendEmailParams.email}\r\nDetails:\r\n${sendEmailParams.message}`;
            this._emailService
                .sendEmail(sendEmailParams)
                .then(() => {
                    ProgressOverlay.deactivate();
                    this.emailFormData.addClass(`d-none`);
                    this.success.removeClass(`d-none`);
                    gaLegacyCustomEvent({
                        eventAction: `Form Submit Success`,
                        eventCategory: `${sendEmailParams.ga_category}` as any,
                        eventLabel: sendEmailParams.ga_label,
                    });
                })
                .catch((submitFormErr: ImpError) => {
                    this.error.removeClass(`d-none`);
                    this.errorMessage.text(submitFormErr.message);
                    gaLegacyCustomEvent({
                        eventAction: `Form Submit Error`,
                        eventCategory: `${sendEmailParams.ga_category}` as any,
                        eventLabel: sendEmailParams.ga_label,
                    });
                    ProgressOverlay.deactivate();
                });
        }
    }

    /**
     * Retrieve data from the server template
     * @private
     */
    private _getServerTemplateData() {
        this._disableRecaptcha = document.getElementById(`serviceDetail___disableRecaptcha`).innerHTML === `true`;
    }

    /**
     * Initializes RecaptchaComponent
     * @private
     */
    private _initRecaptcha() {
        this._recaptchaComponent = new RecaptchaComponent(this._disableRecaptcha, this.submitWebForm.bind(this));
    }

    /**
     * Initializes jquery.validate on webForm
     * @private
     */
    private _initValidationWebForm() {
        $(`input[required]:not([type="checkbox"]), textarea[required]`).after(`<i class="fa fa-exclamation-circle-solid fa-lg error"></i>`);
        this.emailFormData.validate({
            ignore: `:hidden`,
            errorPlacement(error, element) {
                element.parent().find(`i.action`).addClass(`errorState`);
                error.insertAfter(element.next().next(`label`));
            },
            invalidHandler: () => {
                this._recaptchaComponent.reset();
            },
            rules: {
                name: {
                    required: true,
                },
                email: {
                    email: true,
                },
                message: {
                    required: true,
                },
            },
            submitHandler: () => {
                this._recaptchaComponent.execute();
            },
        });
    }

    /**
     * Binds component properties to jQuery selectors
     * @private
     */
    private _performElementBinding() {
        this.emailForm = this.component.find(`[data-binding='default-form-component']`);
        this.error = this.component.find(`[data-binding='email-error']`);
        this.errorMessage = this.component.find(`[data-binding='error-message']`);
        this.impSpinner = this.component.find(`[data-binding='imp-spinner']`);
        this.impSpinnerSize = this.component.find(`[data-spinner-size]`);
        this.success = this.component.find(`[data-binding='email-success']`);
        if (this.emailForm) {
            this.emailFormData = this.component.find(`[data-binding='emailFormData']`);
        }
    }

    /**
     * Registers event handlers on component properties
     * @private
     */
    private _registerEventHandlers() {
        if (this.emailForm && this.emailForm.length > 0) {
            this._initRecaptcha();
            this._initValidationWebForm();
        }
    }
}
